import http from './http'

export function getLoggedInUser() {
  return http.get("/v1/profile/me", { withCredentials: true })
}

export function getMyInbox() {
  return http.get("/v1/notifications/messages", { withCredentials: true })
}

export function getMessageById(message_id) {
  return http.get(`/v1/notifications/messages/${message_id}`, { withCredentials: true })
}
